export default __webpack_public_path__ + "static/media/download.41a4ed68.png";